module.exports = __webpack_public_path__ + "static/media/20ECE29.e2dd4d4c.jpg";